import { useLanguage } from "../../context/LanguageContext";
import { Seo } from "../../components/Seo";
import { LegalShell, Block } from "./LegalShell";

export default function TermsOfService() {
  const { t } = useLanguage();
  const sections = t("legal.terms.sections") || [];
  return (
    <>
      <Seo title={t("legal.terms.seoTitle")} description={t("legal.terms.seoDesc")} />
      <LegalShell
        title={t("legal.terms.title")}
        subtitle={t("legal.terms.intro")}
        updated={t("legal.updatedDate")}
      >
        {sections.map((s, i) => (
          <Block key={i} heading={s.heading}>
            {s.paragraphs.map((p, j) => (
              <p key={j}>{p}</p>
            ))}
          </Block>
        ))}
      </LegalShell>
    </>
  );
}
